// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--wvlka","skeleton-wrapper":"_9e1425b4d3--skeleton-wrapper--ndnxg"};